export const getDeliveredTrainingLabel = (): string => 'Próximo treino';
